import React from 'react';
import Modal from './Modal';
import { LogOut } from 'lucide-react';

export default function LogoutModal({ open, onClose, onConfirm, isLoading = false }) {
  return (
    <Modal open={open} onClose={onClose} title={null}>
      <div className="flex flex-col items-center text-center px-2 py-2 sm:px-6 sm:py-4">
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-[#f4f0f8] text-[#6D4E8A] ring-8 ring-[#f4f0f8]/50">
          <LogOut size={28} className="ml-1" />
        </div>
        
        <h3 className="mb-2 text-xl sm:text-2xl font-semibold text-gray-900 font-['Lexend']">
          Sign Out
        </h3>
        
        <p className="mb-8 text-sm sm:text-base text-gray-500 font-['Poppins']">
          Are you sure you want to sign out of your account? You will need to log in again to access the dashboard.
        </p>

        <div className="flex w-full flex-col sm:flex-row gap-3">
          <button
            onClick={onClose}
            className="flex-1 rounded-xl border border-gray-200 bg-white px-5 py-3.5 text-sm sm:text-base font-medium text-gray-700 transition-all hover:bg-gray-50 hover:text-gray-900 focus:outline-none"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 flex items-center justify-center gap-2 rounded-xl bg-[#6D4E8A] px-5 py-3.5 text-sm sm:text-base font-medium text-white shadow-sm transition-all hover:bg-[#5f4376] hover:shadow focus:outline-none disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isLoading ? "Signing out..." : "Yes, Sign Out"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
